'use client';

import React, { useRef } from 'react';

import { withEventScope } from '@repo/event-processor';

import { CategoryListGrid } from 'strapi/component/categoryList/CategoryListGrid';
import { CategoryListNavigation } from 'strapi/component/categoryList/CategoryListNavigation';
import { FlexColumn } from 'styles/layouts';

import { CategoryListProps } from './types';

const CategoryList: React.FC<CategoryListProps> = (props) => {
  const categories = props.categories.filter((x) => x.items.length);
  const categoriesRefs = useRef<Record<string, HTMLDivElement>>({});

  if (!categories.length) {
    return null;
  }

  return (
    <FlexColumn>
      {props.withNavigation && (
        <CategoryListNavigation
          ref={categoriesRefs}
          categories={categories.map((x) => ({
            name: x.name,
            text: x.name,
            icon: x.icon,
          }))}
        />
      )}
      {categories.map((x) => (
        <CategoryListGrid
          key={x.name}
          ref={categoriesRefs}
          backgroundColor={props.backgroundColor}
          description={x.description}
          items={x.items.map((y) => ({
            url: y.url,
            title: y.title,
            image: y.image,
          }))}
          title={x.name}
        />
      ))}
    </FlexColumn>
  );
};

export default withEventScope(CategoryList, { feature: 'categoryList' });
